import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import SequenceSingleTemplate from './SequenceSingleTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class SequenceSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.SEQUENCE_SINGLE)

    this.data.component = SequenceSingleTemplate
    this.socket = config.sockets ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.SEQUENCE_SINGLE
    this.setConnection()

    const sequenceSingleInput = new Rete.Input(CONST_SOCKET.SEQUENCE_SINGLE_INPUT, lang.sequence_single_socket_input_reply, this.socket.sequenceSingleInput, false)
    const sequenceSingleOutput = new Rete.Output(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT, lang.sequence_single_socket_output_next, this.socket.sequenceSingleOutput, false)

    return node
      .addInput(sequenceSingleInput)
      .addOutput(sequenceSingleOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {

  }

  setConnection() {
    this.socket.sequenceSingleOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.sequenceSingleOutput.combineWith(this.socket.openaiInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.carouselInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.imageInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.videoInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.audioInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.sequenceSingleOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.sequenceSingleOutput.combineWith(this.socket.fileInput)
      // this.socket.sequenceSingleOutput.combineWith(this.socket.otnInput)
    }

    if(recurring_notification_display)
      this.socket.sequenceSingleOutput.combineWith(this.socket.rcnInput)

    this.socket.sequenceSingleOutput.combineWith(this.socket.ecommerceInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.sequenceSingleOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.sequenceSingleOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.sequenceSingleOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.sequenceSingleOutput.combineWith(this.socket.conditionInput)
    }
  }
}